import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState
} from "react";
import { createStore, useStore, type StoreApi } from "zustand";

import { type Till } from "~/api/tills/types";

export type CollectTill =
  | Extract<Till, { type: "collect" }>
  | Extract<Till, { type: "collect-lite" }>;

const CollectTillContext = createContext<StoreApi<CollectTill> | null>(null);

export const CollectTillProvider = ({
  till,
  children
}: PropsWithChildren<{ till: CollectTill }>) => {
  // eslint-disable-next-line react/hook-use-state -- useState for one time initialization (https://tkdodo.eu/blog/use-state-for-one-time-initializations)
  const [store] = useState(() => createStore(() => till));

  useEffect(() => {
    store.setState(till);
  }, [store, till]);

  return (
    <CollectTillContext.Provider value={store}>
      {children}
    </CollectTillContext.Provider>
  );
};

export const useCollectTillContext = <T,>(
  selector: (till: CollectTill) => T
) => {
  const store = useContext(CollectTillContext);
  if (!store) {
    throw new Error("Missing CollectTillProvider");
  }
  return useStore(store, selector);
};
